// import eeuu from '../../images/eeuu.png';
// import arg from '../../images/argentina.png';
// import iconoStock from '../../images/stockDisponible.png';


// export default function CardArticulo({ articulos, openModal }) {


//     return (
//         <>
//             {articulos?.map((art, index) => (
//                 <div
//                     key={index}
//                     className='flex justify-center items-center flex-col bg-white lg:rounded-lg rounded-lg mt-1.5 mb-1.5 m-1 cursor-pointer transition-transform hover:scale-95'
//                     onClick={() => openModal(art)}
//                 >
//                     <p className='text-center text-sm font-semibold'>Precio actualizado al: {art?.Fupcosto ? art.Fupcosto.split('-').reverse().join('/') : ''}</p>

//                     <div className='flex justify-center items-center -mb-1'>
//                         <img
//                             src={art?.Monedadolar.trim() == '1' ? eeuu : arg}
//                             alt="bandera"
//                             className='w-6 h-6 mr-4'
//                         />
//                         <h5 className='text-center text-sm font-bold mr-4'>{art?.Codigo}</h5>
//                         {parseFloat(art?.Stocktotal) > 0 && (
//                             <img src={iconoStock} alt="stock" className='w-7 h-6' />
//                         )}
//                     </div>

//                     <h5 className='text-sm text-center text-black font-bold px-0 lg:px-2'>
//                         {art?.Codorigen?.trim()}
//                     </h5>
//                     <h5 className='text-sm text-center text-blue-700 font-bold px-0 lg:px-2'>
//                         {art?.Descripcion?.trim()}
//                     </h5>

//                     <hr className='border-1 border-black w-72'/>

//                     <div className='flex justify-between w-full px-0 py-1 lg:px-2 lg:py-1'>

//                         {/* Precio Público */}
//                         <div className='self-start mr-0 ml-4 lg:mr-4'>
//                             <p className='text-red-600 font-semibold text-md'>PRECIO PUBLICO</p>
//                             <p className='text-sm'>
//                                 <strong className='font-black'>PvtaP1 :</strong>{' '}
//                                 {(parseFloat(art?.Prevtapub1) * ((art?.Alicuota / 100) + 1)).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                             </p>
//                             <p className='text-sm'>
//                                 <strong className='font-black'>PvtaP2 :</strong>{' '}
//                                 {(parseFloat(art?.Prevtapub2) * ((art?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                 })}
//                             </p>
//                             <p className='text-sm'>
//                                 <strong className='font-black'>PvtaP3 :</strong>{' '}
//                                 {(parseFloat(art?.Prevtapub3) * ((art?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                 })}
//                             </p>
//                         </div>


//                         {/* Precio Mayorista */}
//                         <div className='self-end mr-4'>
//                             <p className='text-red-600 font-semibold text-md'>PRECIO MAYORISTA</p>
//                             <p className='text-sm'>
//                                 <strong className='font-black'>PvtaM1 :</strong>{' '}
//                                 {(parseFloat(art?.Prevtamay1) * ((art?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                 })}
//                             </p>
//                             <p className='text-sm'>
//                                 <strong className='font-black'>PvtaM2 :</strong>{' '}
//                                 {(parseFloat(art?.Prevtamay2) * ((art?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                 })}
//                             </p>
//                             <p className='text-sm'>
//                                 <strong className='font-black'>PvtaM3 :</strong>{' '}
//                                 {(parseFloat(art?.Prevtamay3) * ((art?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                 })}
//                             </p>
//                         </div>


//                     </div>

//                 </div>

//             ))}
//         </>



//     );

// }


import eeuu from '../../images/eeuu.png';
import arg from '../../images/argentina.png';
import iconoStock from '../../images/stockDisponible.png';

export default function CardArticulo({ articulos, openModal }) {
    // Función auxiliar para formatear moneda y no repetir código
    const formatPrice = (price, alicuota) => {
        const total = parseFloat(price) * ((alicuota / 100) + 1);
        return total.toLocaleString("es-AR", { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
        });
    };

    const filaPrecio = (etiqueta, valor, alicuota) => (
        <div className='flex items-baseline justify-between gap-2 text-[13px]'>
            <span className='text-slate-400 dark:text-slate-500'>{etiqueta}</span>
            <span className='font-semibold tabular-nums text-slate-900 dark:text-slate-100'>$ {formatPrice(valor, alicuota)}</span>
        </div>
    );

    return (
        <>
            {articulos?.map((art, index) => (
                <div
                    key={index}
                    className='group flex w-full cursor-pointer flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition duration-200 hover:-translate-y-0.5 hover:border-brand-200 hover:shadow-md active:scale-[0.99] dark:border-slate-800 dark:bg-slate-900 dark:shadow-none dark:hover:border-brand-700 md:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.667rem)] lg:max-w-sm'
                    onClick={() => openModal(art)}
                >
                    <div className='flex flex-1 flex-col p-4'>
                        {/* Fila: Bandera, Código y Stock */}
                        <div className='mb-3 flex items-center justify-between gap-2'>
                            <div className='flex min-w-0 items-center gap-2'>
                                <img
                                    src={art?.Monedadolar.trim() == '1' ? eeuu : arg}
                                    alt="moneda"
                                    className='h-4 w-6 shrink-0 rounded-[3px] object-cover ring-1 ring-black/5'
                                />
                                <span className='truncate rounded-md bg-slate-100 px-2 py-0.5 font-mono text-xs font-semibold text-slate-700 dark:bg-slate-800 dark:text-slate-300'>
                                    {art?.Codigo}
                                </span>
                            </div>
                            {parseFloat(art?.Stocktotal) > 0 && (
                                <div className='flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 py-0.5 pl-1 pr-2 ring-1 ring-inset ring-emerald-600/15 dark:bg-emerald-500/10 dark:ring-emerald-400/20'>
                                    <img src={iconoStock} alt="stock" className='h-4 w-4' />
                                    <span className='text-[11px] font-semibold text-emerald-700 dark:text-emerald-400'>En stock</span>
                                </div>
                            )}
                        </div>

                        {/* Títulos */}
                        <div className='mb-3'>
                            {art?.Codorigen?.trim() && (
                                <p className='mb-0.5 font-mono text-[11px] uppercase tracking-wide text-slate-400 dark:text-slate-500'>
                                    {art?.Codorigen?.trim()}
                                </p>
                            )}
                            <h5 className='text-[15px] font-semibold leading-snug text-slate-900 dark:text-white lg:text-sm'>
                                {art?.Descripcion?.trim()}
                            </h5>
                        </div>

                        {/* Grilla de Precios */}
                        <div className='mt-auto grid grid-cols-2 gap-px overflow-hidden rounded-xl bg-slate-200/70 ring-1 ring-slate-200/70 dark:bg-slate-800 dark:ring-slate-800'>
                            {/* Columna Público */}
                            <div className='min-w-0 bg-slate-50/70 px-2.5 py-3 dark:bg-slate-900 sm:p-3'>
                                <p className='mb-2 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400'>
                                    <span className='h-1.5 w-1.5 rounded-full bg-brand-500' />
                                    Público
                                </p>
                                <div className='space-y-1'>
                                    {filaPrecio('P1', art?.Prevtapub1, art?.Alicuota)}
                                    {filaPrecio('P2', art?.Prevtapub2, art?.Alicuota)}
                                    {filaPrecio('P3', art?.Prevtapub3, art?.Alicuota)}
                                </div>
                            </div>

                            {/* Columna Mayorista */}
                            <div className='min-w-0 bg-slate-50/70 px-2.5 py-3 dark:bg-slate-900 sm:p-3'>
                                <p className='mb-2 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400'>
                                    <span className='h-1.5 w-1.5 rounded-full bg-amber-500' />
                                    Mayorista
                                </p>
                                <div className='space-y-1'>
                                    {filaPrecio('M1', art?.Prevtamay1, art?.Alicuota)}
                                    {filaPrecio('M2', art?.Prevtamay2, art?.Alicuota)}
                                    {filaPrecio('M3', art?.Prevtamay3, art?.Alicuota)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Pie: fecha de actualización + acción */}
                    <div className='flex items-center justify-between gap-2 border-t border-slate-100 px-4 py-2 dark:border-slate-800'>
                        <p className='text-[11px] text-slate-500 dark:text-slate-400'>
                            Actualizado: <span className='font-medium text-slate-600 dark:text-slate-300'>{art?.Fupcosto ? art.Fupcosto.split('-').reverse().join('/') : '--/--/----'}</span>
                        </p>
                        <span className='flex items-center gap-0.5 text-xs font-semibold text-brand-600 dark:text-brand-400'>
                            Ver detalle
                            <svg className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.25" d="M9 5l7 7-7 7" />
                            </svg>
                        </span>
                    </div>
                </div>
            ))}
        </>
    );
}
